module.exports = __webpack_public_path__ + "img/12.ed74b67a.svg";